// PlayerUiCommand.ts
/**
 * Команды для работы с player (namespace = "player").
 */
var PlayerUiCommand;
(function (PlayerUiCommand) {
    PlayerUiCommand["editFootage"] = "editfootage";
})(PlayerUiCommand || (PlayerUiCommand = {}));

export { PlayerUiCommand };
